import type { AnyRoute } from '@tanstack/react-router';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

export const createTaskListsRoutes = <TParent extends AnyRoute>(
  parent: TParent
) => {
  const taskListsRoute = createRoute({
    path: '/task-lists',
    getParentRoute: () => parent,
    component: lazyRouteComponent(() => {
      return import('./pages/TaskListsPage');
    })
  });

  return [taskListsRoute];
};
